import Vue from 'vue/dist/vue.js';
import axios from 'axios';
import Notifications from 'vue-notification'
import VueRouter from 'vue-router';
import Verify from './components/Verify.vue';
import AutoVerify from './components/AutoVerify.vue';
// import ManageBooking from './components/ManageBooking.vue';
// import ManageBooking_1 from './components/ManageBooking_1.vue';
import VerifiedBookingDetail from './components/VerifiedBookingDetail.vue';
import Confirmation from './components/Confirmation.vue';
import Failure from './components/Failure.vue';
import VueCookies from 'vue-cookies';
import moment from 'moment'

// Filters
Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
    }
})
  
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
})

Vue.filter('formatTimeShort', function(value) {
    if (value) {
        return moment(String(value)).format('HH:mm')
    }
})

Vue.filter('formatCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(Notifications)

Vue.prototype.$api = process.env.MIX_API_URL

const routes = [
    {
        path: '/',
        name: 'verify',
        component: Verify
    },
    {
        path: '/auto-verify',
        name: 'auto-verify',
        component: AutoVerify
    },
    {
        path: '/manage-booking',
        name: 'manage-booking',
        component: VerifiedBookingDetail
    },
    {
        path: '/confirmation',
        name: 'confirmation',
        component: Confirmation
    },
    {
        path: '/failure',
        name: 'failure',
        component: Failure
    }
]

const router = new VueRouter({
    routes
})

new Vue({
    router,
    el: '#my-bookings-app',
    data: {
        loading: false,
        booking: {
            customer: {},
            tour_bookings: [],
            passengers: [],
            discount: null,
            extras: []
        },
        verificationData: {
            booking_ref_no: null,
            surname: null,
            departure_date: null
        },
        stripeLoaded: false
    },
    computed: {},
    created() {},
    watch: {}
});